// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\TagResponse

export type TagApiResponse = {
	tags: string[];
};

export type Tag = {
	tags: string[];
};

export function hydrateTag(data: TagApiResponse): Tag {
	return { ...data };
}